<template>
  <div v-if="isShowL4Header" id="BANotify_Level4">
    <div class="header-group">
      <div class="header" :class="{ 'disabled': !firstPublicBAData }">
        <div class="header-right">
          <i class="icon-warning"></i>
          <div class="warning-text">
            公區告警：L4-災害級警報
          </div>
        </div>
        <div v-if="publicBAData.length > 1" class="sum" @click="$openNewPageToPath({ name:'baEvent', query: { area: 'public' }})">
          查看其他 {{ publicBAData.length - 1 }} 則
          <i class="icon-m-next"></i>
        </div>
      </div>
      <div class="header" :class="{ 'disabled': !firstPrivateBAData }">
        <div class="header-right">
          <i class="icon-warning"></i>
          <div class="warning-text">
            私區告警：L4-災害級警報
          </div>
        </div>
        <div v-if="privateBAData.length > 1" class="sum" @click="$openNewPageToPath({ name:'baEvent', query: { area: 'private' }})">
          查看其他 {{ privateBAData.length - 1 }} 則
          <i class="icon-m-next"></i>
        </div>
      </div>
    </div>
    <div class="notifyGroup">
      <div class="notify-area" :class="{ 'disabled': !firstPublicBAData }">
        <div class="notify">
          <template v-if="firstPublicBAData">
            <div class="content">
              <i class="icon-ba-public">
                <i class="path1"></i>
                <i class="path2"></i>
                <i class="path3"></i>
              </i>
              <div>
                <div class="message">
                  {{ firstPublicBAData.title }}
                </div>
                <div class="assetPosition">
                  設備位置：
                  {{ firstPublicBAData.data.AssetPosition }}
                </div>
              </div>
            </div>
            <button class="reportBtn" @click="$openNewPageToPath({ name:'reportEventById', params: { id: firstPublicBAData.data.Id }})">
              前往回報
              <i class="icon-m-next"></i>
            </button>
          </template>
          <template v-else>
            <div class="empty-notify">
              目前無公區災害級警報事件
            </div>
          </template>
        </div>
      </div>
      <div class="notify-area" :class="{ 'disabled': !firstPrivateBAData }">
        <div class="notify">
          <template v-if="firstPrivateBAData">
            <div class="content">
              <i class="icon-ba-private">
                <i class="path1"></i>
                <i class="path2"></i>
                <i class="path3"></i>
              </i>
              <div>
                <div class="message">
                  {{ firstPrivateBAData.title }}
                </div>
                <div class="assetPosition">
                  位置：
                  {{ firstPrivateBAData.data.AssetPosition }}
                </div>
              </div>
            </div>
            <button class="reportBtn" @click="$openNewPageToPath({ name:'reportPrivateEventById', params: { id: firstPrivateBAData.data.Id }})">
              前往回報
              <i class="icon-m-next"></i>
            </button>
          </template>
          <template v-else>
            <div class="empty-notify">
              目前無私區災害級警報事件
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    publicBAData () {
      return this.$store.state.localStorage['BA-alert']?.level4 || JSON.parse(localStorage.getItem('BA-alert'))?.level4 || []
    },
    privateBAData () {
      return this.$store.state.localStorage['BA-private-alert']?.level4 || JSON.parse(localStorage.getItem('BA-private-alert'))?.level4 || []
    },
    firstPublicBAData () {
      if (this.publicBAData && this.publicBAData.length > 0) return this.publicBAData[0]
      return null
    },
    firstPrivateBAData () {
      if (this.privateBAData && this.privateBAData.length > 0) return this.privateBAData[0]
      return null
    },
    isAlarmEnabled () {
      return this.$store.getters.isServiceEnabled(24)
    },
    isShowL4Header () {
      return this.isAlarmEnabled && (this.publicBAData.length > 0 || this.privateBAData.length > 0)
    }
  },
  watch: {
    publicBAData: {
      handler: function (val, oldVal) {
        this.$nextTick(function () {
          document.getElementById('NotifyLayout').style.top = document.getElementById('app-header').offsetHeight + 'px'
          document.getElementById('NotifyLayout').style['max-height'] = `calc( 100vh - ${document.getElementById('app-header').offsetHeight}px )`
        })
      }
    },
    privateBAData: {
      handler: function (val, oldVal) {
        this.$nextTick(function () {
          document.getElementById('NotifyLayout').style.top = document.getElementById('app-header').offsetHeight + 'px'
          document.getElementById('NotifyLayout').style['max-height'] = `calc( 100vh - ${document.getElementById('app-header').offsetHeight}px )`
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
#BANotify_Level4
  .header-group
    display: flex
    align-items: stretch
    .header
      width: 100%
      display: flex
      justify-content: space-between
      padding: 16px 36px
      position: sticky
      top: 0
      left: 0
      background-color: #ee5858
      z-index: 2
      color: $white
      &.disabled
        background-color: #e0e0e0
      .header-right
        display: flex
        align-items: center
        .icon-warning
          font-size: 60px
          margin-right: 12px
        .warning-text
          font-size: 29px
          line-height: 60px
          font-weight: 600
      .sum
        cursor: pointer
        flex: right
        display: flex
        align-items: center
        font-size: 25px
        line-height: 60px
        i
          font-size: 20px
          margin-left: 4px
  .notifyGroup
    display: flex
    height: 180px
    overflow: auto
    box-sizing: border-box
    .notify-area
      width: 100%
      padding: 8px 8px 8px 16px
      background-color: #ee5858
      &.disabled
        background-color: #e0e0e0
    .notify
      display: flex
      align-items: center
      justify-content: space-between
      height: 130px
      background-color: $white
      border-radius: 16px
      margin-bottom: 12px
      padding: 12px 28px
      .empty-notify
        width: 100%
        font-size: 28px
        text-align: center
        color: $grayFontColor
      .content
        display: flex
        align-items: center
        .icon-ba-public,
        .icon-ba-private
          font-size: 76px
          margin-right: 10px
        .message
          font-size: 27px
          line-height: 38px
          font-weight: 600
          margin-bottom: 8px
          +word-break-line(1)
        .assetPosition
          display: flex
          font-size: 25px
          line-height: 35px
          +word-break-line(2)
      .reportBtn
        display: flex
        align-items: center
        background-color: #ee5858
        color: $white
        padding: 14px 26px
        height: 60px
        border-radius: 8px
        font-size: 23px
        line-height: 32px
        outline: unset
        border: unset
        text-wrap: nowrap
        .icon-m-next
          vertical-align: middle
          margin-left: 5px
          font-size: 18px
</style>
